import Rest from '../Rest'

/**
 * "Minhas taxas" do estabelecimento: plano vigente + posição no período +
 * simulador — tudo escopado pelo data-access (o backend decide o quê).
 */
export default class MyFeesService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/financial/fees'

  static build(vs = null) {
    return new this(this.resource, null, vs)
  }

  current() {
    return this.get('/current')
  }

  simulate(data) {
    return this.post('/simulate', data)
  }
}
